import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-high-speed",
  "use": "icon-high-speed-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-high-speed\"><path d=\"M707.8 32H557l17.4 190.5c0.8 9.4-6.5 17.5-15.9 17.5h-93.9c-9.4 0-16.8-8.1-15.9-17.5L467 32H287L0 992h374.6l18.8-195.1c1.6-16.4 15.4-28.9 31.9-28.9H595c16.5 0 30.4 12.6 31.9 29.1L644.6 992H1024L707.8 32zM413.2 590.5L428.8 429c1.6-16.4 15.4-28.9 31.9-28.9h100.7c16.5 0 30.4 12.6 31.9 29.1L608 590.5c0.8 9.4-6.5 17.5-15.9 17.5H429.2c-9.5 0-16.9-8.1-16-17.5z\" p-id=\"2257\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol